export default __webpack_public_path__ + "static/media/filter.a49e6261.svg";